/**
 * Shared `data-test-id` values used by `@sib/ui` and SpendBrain so selectors stay aligned.
 */
export const FILE_PREVIEW_ROOT_TEST_ID = 'file-preview' as const;
export const FILE_MANAGER_DROPZONE_TEST_ID = 'file-dropzone' as const;
export const CONFIRM_FILES_UPLOAD_TEST_ID =
  'confirm-files-upload-button' as const;

/**
 * @example
 * // Component applies: `${baseId}-${TableTextInputSuffix.Edit}`
 * // Selector targets: `[data-test-id="${TestIds.DocumentFilenameEditor}-${TableTextInputSuffix.Edit}"]`
 */
export enum TableTextInputSuffix {
  Edit = 'edit',
  Input = 'input',
  Confirm = 'confirm',
  Cancel = 'cancel',
}
